var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 147954",
    width: 24,
    height: 24,
    transform: "translate(295 628)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-295 -628)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "edit",
    transform: "translate(297.789 630.791)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 93",
    d: "M17.228,1.22a4.063,4.063,0,0,0-5.75,0L.936,11.759a.527.527,0,0,0-.149.3L.005,17.847a.526.526,0,0,0,.149.444.536.536,0,0,0,.373.157.427.427,0,0,0,.071,0l5.72-.766a.531.531,0,0,0-.141-1.052l-.237.883a.536.536,0,0,0,.373.157.52.52,0,0,0,.373-.157L17.228,6.97a4.06,4.06,0,0,0,0-5.75Zm-.553,4.789L12.44,1.774a3.009,3.009,0,0,1,4.235,4.235Z",
    transform: "translate(0 -0.028)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenFilled);
export default __webpack_public_path__ + "static/media/pen-filled.1b4be74f.svg";
export { ForwardRef as ReactComponent };